
import { HttpInterceptorFn } from "@angular/common/http";
import {
    inject,
    DOCUMENT,
} from "@angular/core";
import { environment } from "../../environments/environment";

export const mirrorUrlResolverInterceptor: HttpInterceptorFn = (request, next) => {

    const document = inject(DOCUMENT);
    // @ts-ignore
    if (environment.domain !== "DEV" || environment.domain !== "LOCAL") {
        if (document.defaultView) {
            const currentHost = document.defaultView.location.host.split(".")[0];
            const projectHost = environment.uniqueProjectTranslation.projectName.toLowerCase();

            if (environment.production && currentHost !== projectHost) {
                const TEMP = "TEMP";
                let url = request.url.replace(projectHost, TEMP);
                url = url.replace(projectHost, currentHost);
                url = url.replace(TEMP, projectHost);
                const dupReq = request.clone({ url });
                return next(dupReq);
            }
        }
    }
    return next(request);
};
